export default function isTuffAthletics() {
  const url = (window.location.href || '').toLowerCase();
  return url.includes('tuffathletics');
}
